import axios from 'app/infrastructure/axiosInstance';
import Notification from "app/models/Notification";
import * as config from 'app/configs/configs';
const baseApiUrl = config.getBaseApiUrl();

interface WebPushNotificationProps {
    getAll(): Promise<Notification[]>
    getUnread(): Promise<Notification[]>
    markAllRead(): Promise<void>
}


export const WebPushNotificationsProvider: WebPushNotificationProps = {

    getAll: async () =>   (await axios.get(`${baseApiUrl}/user-notifications/all`))?.data?.data,
    getUnread: async () => (await axios.get(`${baseApiUrl}/user-notifications/unread`))?.data?.data,
    markAllRead: async () => (await axios.post(`${baseApiUrl}/user-notifications/mark-all-read`))?.data?.data,
}

